import { http } from "@/lib/http";
export function fetchStampCards() {
  return http
    .get("/api/campaigns/getStampList")
    .then((res) => res.data?.data?.stampCardList || []);
}
export function deleteStampCard(id) {
  return http
    .delete(`/api/campaigns/deleteStampImages/${id}`)
    .then((res) => res.data);
}
export function fetchStampCard(id) {
  return http
    .get(`/api/campaigns/getStampImages/${id}`)
    .then((res) => res.data?.data || null);
}
export function addStampCard(payload) {
  return http
    .post("/api/campaigns/addStampImages", payload)
    .then((res) => res.data);
}
export function updateStampCard(id, payload) {
  return http
    .post(`/api/campaigns/updateStampImages/${id}`, payload)
    .then((res) => res.data);
}
